import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Formik } from 'formik';
import Button from '../components/Button';
import { Field, FieldLabel, FieldSelect } from '../components/Field';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { updateSpaceMemberCache } from '../utilities/cache';
import { UPDATE_SPACE_USER_ROLE } from '../utilities/mutations';

const EditRoleModal = ({ member, onClose }) => {
  const params = useParams();
  const toast = useToast();
  const [updateSpaceMemberRole] = useMutation(UPDATE_SPACE_USER_ROLE);

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()}>
      <ModalExit />
      <ModalName>Change {member.user.name}'s role</ModalName>
      <Formik
        initialValues={{
          role: member.role.toUpperCase(),
        }}
        onSubmit={async (values) => {
          try {
            await updateSpaceMemberRole({
              variables: {
                spaceSlug: params.s,
                userId: member.user.id,
                role: values.role,
              },
              update: (cache, { data: { updateSpaceMemberRole } }) =>
                updateSpaceMemberCache(cache, updateSpaceMemberRole),
            });
            toast({
              children: `${member.user.name} is now ${
                values.role === 'ADMIN' ? 'an' : 'a'
              } ${values.role.toLowerCase()}`,
            });
          } catch (error) {
            toast({ children: error.message });

            return;
          }

          close();
        }}
      >
        {({ values, handleSubmit, isSubmitting, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <ModalPart>
              <Field>
                <FieldLabel>Role</FieldLabel>
                <FieldSelect
                  onChange={(e) => setFieldValue('role', e.target.value)}
                  value={values.role}
                  data-autofocus
                >
                  <option disabled selected value>
                    Choose a role
                  </option>
                  <option value="ADMIN">Admin</option>
                  <option value="USER">User</option>
                </FieldSelect>
              </Field>
            </ModalPart>
            <ModalPart>
              <Button
                type="submit"
                disabled={
                  member.role.toUpperCase() === values.role || isSubmitting
                }
                isPrimary
                isExtended
              >
                Change
              </Button>
            </ModalPart>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditRoleModal;
